// faq — or. FAQ page chrome. The Q&A bodies themselves live under faq1q..faq8a.

export default {
  faqHeroA: 'Qabiyyee',
  faqHeroB: 'Barreeffamaa',
  faqSearchPlaceholder: 'Qabiyyeffama barbaadi...',
  faqCatAll: 'Gosota Hunda',
  faqCatAccount: 'Eegaa',
  faqCatBuying: 'Boughtuu',
  faqCatSelling: 'Gurgurtootaa',
  faqCatPayments: 'Kaffaltii',
  faqCatDelivery: 'Geejjiba',
  faqNoMatch: 'Barbaadinni kee biraaseen qabiyyee hin argamne.',
  faqStillTitle: 'Amma qabiyye argadhu?',
  faqStillDesc: 'Kootuu keenya gargaarsa yoo siif ta’e yoo barbaachisan hunda ni gargaara.',
  faqContactSupport: 'Gargaarsa Qabeessi',
  faqCtaTitle: 'Barbaadan hin argatin?',
  faqCtaDesc: 'Kootuu keenya AllThings ilaa qabiyyeewwan hunda deebisuu qofa jedhani qophaa’e dha.',
  faqPhoneLabel: (n) => `Bilbilaa ${n}`,
  faqSupportHours: 'Waqtii Gargaarsaa',
};